import { Injectable } from '@angular/core';
import { buildCouponUses, CouponService, CouponUses } from '../shared-lib/domains/coupon';
import { PiggyService, PiggyTransactionOption, PiggyTransactionType } from '../shared-lib/domains/piggy';
import { UserService } from '../shared-lib/domains/user';
//prueba commit conjunto app y shared-lib
@Injectable({ providedIn: 'root' })
export class CouponFlows {

  constructor(
    private couponService: CouponService,
    private piggyService: PiggyService,
    private userService: UserService
  ) { }

  async validateCoupon(data): Promise<any> {
    const userId = this.userService.userG?.id;

    if (!userId && !data.email) {
      return Promise.reject(new Error("fail-invalid currentUser"));
    }

    if (userId) {
      data.userId = userId;
      delete data.email;
    }

    return this.couponService.verifyCoupon(data);
  }

  /**
   * Get combined coupon usage stats and fee amounts for a given coupon and user.
   * Coordinates piggy and coupon domains.
   */
  async getCouponUses(
    couponCode: string,
    userId: string,
    piggyTransactionType: PiggyTransactionType,
    piggyTransactionOption: PiggyTransactionOption
  ): Promise<CouponUses> {
    if (!couponCode) return undefined;
    try {
      const [feeAmounts, usageStats] = await Promise.all([
        this.piggyService.getMonthlyFeeAmounts(userId, piggyTransactionType, piggyTransactionOption),
        this.couponService.getCouponUsageStats({ couponCode })
      ]);
      return buildCouponUses(feeAmounts, usageStats);
    } catch (error) {
      console.error(error);
      return undefined;
    }
  }
}

